module.exports = __webpack_public_path__ + "img/news37-0.7eb79770.png";